module.exports = __webpack_public_path__ + "img/Z81_01.24815097.jpg";